if (!customElements.get('reaction-video-carousel')) {
  customElements.define(
    'reaction-video-carousel',
    class extends HTMLElement {
      connectedCallback() {
        this.videos = [...this.querySelectorAll('video')];
        this.visibility = new Map();
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.handleClick = this.handleClick.bind(this);
        this.addEventListener('click', this.handleClick);

        this.videos.forEach((video) => this.updateButtons(video));
        this.loadObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              this.loadVideo(entry.target);
              this.loadObserver.unobserve(entry.target);
            });
          },
          { rootMargin: '300px 0px' }
        );
        this.playObserver = new IntersectionObserver(
          (entries) => this.handleIntersection(entries),
          { threshold: [0, 0.1, 0.35, 0.75] }
        );
        this.videos.forEach((video) => {
          this.loadObserver.observe(video);
          this.playObserver.observe(video);
        });
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.loadObserver?.disconnect();
        this.playObserver?.disconnect();
        this.videos?.forEach((video) => video.pause());
      }

      loadVideo(video) {
        if (video.dataset.poster && !video.poster) video.poster = video.dataset.poster;
        if (video.dataset.src && !video.src) {
          video.src = video.dataset.src;
          video.load();
        }
      }

      handleIntersection(entries) {
        entries.forEach((entry) => {
          this.visibility.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
        });

        this.videos.forEach((video) => {
          if (!this.reducedMotion && (this.visibility.get(video) || 0) >= 0.1) {
            this.loadVideo(video);
            video.play().then(() => this.updateButtons(video)).catch(() => {});
          } else {
            video.pause();
            this.updateButtons(video);
          }
        });
      }

      updateButtons(video) {
        const slide = video.closest('.reaction-videos__slide');
        const button = slide?.querySelector('[data-reaction-audio]');
        const soundOn = !video.muted;
        if (button) {
          button.setAttribute('aria-pressed', String(soundOn));
          button.setAttribute('aria-label', soundOn ? 'Mute video' : 'Turn sound on');
        }
        const playbackButton = slide?.querySelector('[data-reaction-playback]');
        if (playbackButton) {
          playbackButton.setAttribute('aria-pressed', String(!video.paused));
          playbackButton.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
        }
      }

      handleClick(event) {
        const button = event.target.closest('[data-reaction-audio], [data-reaction-playback]');
        if (!button) return;
        const video = button.closest('.reaction-videos__slide')?.querySelector('video');
        if (!video) return;

        if (button.matches('[data-reaction-playback]')) {
          this.loadVideo(video);
          if (video.paused) {
            video.play().then(() => this.updateButtons(video)).catch(() => {});
          } else {
            video.pause();
            this.updateButtons(video);
          }
          return;
        }

        const enableSound = video.muted;
        document.querySelectorAll('reaction-video-carousel video').forEach((candidate) => {
          candidate.muted = true;
          candidate.closest('reaction-video-carousel')?.updateButtons(candidate);
        });
        this.loadVideo(video);
        video.muted = !enableSound;
        video.play().then(() => this.updateButtons(video)).catch(() => {});
      }
    }
  );
}
